module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/arrow-e1c9a4fa87d2e04bb1741a1a2c5c2fe7.svg";